import PropTypes from "prop-types"
import React from "react"

export const accountBenefitPropType = PropTypes.shape({
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
})

const AccountBenefit = ({ benefit }) => (
  <div className="flex items-center gap-3">
    <i className={`${benefit.icon} fa-fw fa-lg text-teal-600`} />
    <div className="flex flex-col">
      <span className="font-semibold text-gray-900">{benefit.title}</span>
      <span className="text-sm text-gray-700">{benefit.description}</span>
    </div>
  </div>
)

AccountBenefit.propTypes = {
  benefit: accountBenefitPropType.isRequired,
}

export default AccountBenefit
